import angular from 'angular';

// A common controller shared between the market and admin style guides.
//
// Uses the URL ($stateParams) to determine which module is being viewed in
// isolation, and sets that on the scope. This allows us to use the same
// template for the list view and single/isolated views of each module in the
// styleguide.
module.exports = angular.module('common.controllers.style-single', [])
.controller('commonStyleSingleCtrl', class {
  constructor($stateParams, $scope) {
    if ($stateParams.moduleName) {
      $scope.moduleName = $stateParams.moduleName;
    } else {
      // TODO(azirbel): Handle module not found?
    }
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/controllers/style-single.js
 **/